import { User } from './user';

export class UserPermission {
  uuid!: string;
  user_uuid!: string;
  date_created!: number;
  date_updated!: number;
  date_deleted!: number;
  claims!: number;
  preauthorisations!: number;
  benefit_bookings!: number;
  tickets!: number;
  members!: number;
  dependents!: number;
  companies!: number;
  member_contribution_invoices!: number;
  interim_contribution_invoices!: number;
  company_contribution_invoices!: number;
  adjustments!: number;
  member_contribution_receipts!: number;
  company_contribution_receipts!: number;
  funder_deposits!: number;
  funder_withdrawals!: number;
  payment_advices!: number;
  exchange_rates!: number;
  management_fees!: number;
  agent_commissions!: number;
  claim_reason_codes!: number;
  fund_rules!: number;
  icd10_codes!: number;
  medical_conditions!: number;
  banks!: number;
  member_reason_codes!: number;
  company_reason_codes!: number;
  corporate_lapsing!: number;
  integrations!: number;
  modifiers!: number;
  schemes!: number;
  service_types!: number;
  tasks!: number;
  tariff_codes!: number;
  members_reports!: number;
  dependents_reports!: number;
  claims_reports!: number;
  preauthorisations_reports!: number;
  // Atenza parity (Reports sidebar), 2026-06-30 — was missing on WeMAS.
  benefit_bookings_reports!: number;
  providers_reports!: number;
  companies_reports!: number;
  billing_statement!: number;
  verify_member!: number;
  waiting_periods!: number;
  verify_benefit!: number;
  medical_records!: number;
  tariff_lookup!: number;
  icd10_lookup!: number;
  payment_methods!: number;
  financial_statement  !: number;
  ahfoz_directories!: number;
  providers!: number;
  users!: number;
  agents!: number;
  agent_groups!: number;
  scheme_groups!: number;
  mobile_banners!: number;
  claim_payouts!: number;
  // Stage 4 PR 10 FE — Phase 3C / Stage 3 permission columns,
  // 2026-05-14. Backed by the BE columns added in PR 10 BE.
  claim_one_time_passwords!: number;
  user_one_time_passwords!: number;
  dependent_one_time_passwords!: number;
  commission_payouts!: number;
  sms_logs!: number;
  email_logs!: number;
  sms_templates!: number;
  email_templates!: number;
  membership_reports!: number;
  financial_reports!: number;
  more_reports!: number;
  benefit_booking_codes!: number;
  preauthorisation_codes!: number;
  dashboard_main!: number;
  dashboard_executive!: number;
  // Stage 5 PR 91 FE — B14.PERMS-C Atenza port, 2026-05-18.
  // Backed by BE columns added in PR 89 (Round 1 BE foundation).
  benefits_maintenance!: number;
  billing_integrity!: number;
  // 2026-07-03 WAVE 4 — Notifications (the bell) + Ticket Ratings
  // (Administration report). Atenza parity (#89 NOTIF / #90 TICKETS R3).
  // Both the declaration AND the constructor assignment are required —
  // PermissionService reads the column off the constructed object, so a
  // missing assignment silently fails the permission check (PR 91.1).
  notifications!: number;
  ticket_ratings!: number;

  user!: User;

  constructor(data: any) {
    this.uuid = data.uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;
    this.date_deleted = data.date_deleted;
    this.user_uuid = data.user_uuid;
    this.claims = data.claims;
    this.preauthorisations = data.preauthorisations;
    this.benefit_bookings = data.benefit_bookings;
    this.tickets = data.tickets;
    this.members = data.members;
    this.dependents = data.dependents;
    this.companies = data.companies;
    this.member_contribution_invoices = data.member_contribution_invoices;
    this.interim_contribution_invoices = data.interim_contribution_invoices;
    this.company_contribution_invoices = data.company_contribution_invoices;
    this.adjustments = data.adjustments;
    this.member_contribution_receipts = data.member_contribution_receipts;
    this.company_contribution_receipts = data.company_contribution_receipts;
    this.funder_deposits = data.funder_deposits;
    this.funder_withdrawals = data.funder_withdrawals;
    this.payment_advices = data.payment_advices;
    this.exchange_rates = data.exchange_rates;
    this.management_fees = data.management_fees;
    this.claim_reason_codes = data.claim_reason_codes;
    this.fund_rules = data.fund_rules;
    this.icd10_codes = data.icd10_codes;
    this.medical_conditions = data.medical_conditions;
    this.member_reason_codes = data.member_reason_codes;
    this.company_reason_codes = data.company_reason_codes;
    this.corporate_lapsing = data.corporate_lapsing;
    this.integrations = data.integrations;
    this.banks = data.banks;
    this.modifiers = data.modifiers;
    this.schemes = data.schemes;
    this.service_types = data.service_types;
    this.tasks = data.tasks;
    this.tariff_codes = data.tariff_codes;
    this.members_reports = data.members_reports;
    this.dependents_reports = data.dependents_reports;
    this.claims_reports = data.claims_reports;
    this.preauthorisations_reports = data.preauthorisations_reports;
    this.benefit_bookings_reports = data.benefit_bookings_reports;
    this.providers_reports = data.providers_reports;
    this.companies_reports = data.companies_reports;
    this.billing_statement = data.billing_statement;
    this.verify_member = data.verify_member;
    this.waiting_periods = data.waiting_periods;
    this.verify_benefit = data.verify_benefit;
    this.medical_records = data.medical_records;
    this.tariff_lookup = data.tariff_lookup;
    this.icd10_lookup = data.icd10_lookup;
    this.payment_methods = data.payment_methods;
    this.financial_statement = data.financial_statement;
    this.ahfoz_directories = data.ahfoz_directories;
    this.providers = data.providers;
    this.users = data.users;
    this.agent_commissions = data.agent_commissions;
    this.agents = data.agents;
    this.agent_groups = data.agent_groups;
    this.scheme_groups = data.scheme_groups;
    this.mobile_banners = data.mobile_banners;
    this.claim_payouts = data.claim_payouts;
    // Stage 4 PR 10 FE — Phase 3C / Stage 3 permission columns,
    // 2026-05-14.
    this.claim_one_time_passwords = data.claim_one_time_passwords;
    this.user_one_time_passwords = data.user_one_time_passwords;
    this.dependent_one_time_passwords = data.dependent_one_time_passwords;
    this.commission_payouts = data.commission_payouts;
    this.sms_logs = data.sms_logs;
    this.email_logs = data.email_logs;
    this.sms_templates = data.sms_templates;
    this.email_templates = data.email_templates;
    this.membership_reports = data.membership_reports;
    this.financial_reports = data.financial_reports;
    this.more_reports = data.more_reports;
    this.benefit_booking_codes = data.benefit_booking_codes;
    this.preauthorisation_codes = data.preauthorisation_codes;
    this.dashboard_main = data.dashboard_main;
    this.dashboard_executive = data.dashboard_executive;
    // Stage 5 PR 91 FE — B14.PERMS-C Atenza port, 2026-05-18.
    this.benefits_maintenance = data.benefits_maintenance;
    this.billing_integrity = data.billing_integrity;
    // 2026-07-03 WAVE 4 — Notifications + Ticket Ratings (Atenza parity).
    this.notifications = data.notifications;
    this.ticket_ratings = data.ticket_ratings;

    if (data.user) {
      this.user = new User(data.user);
    }
  }
}
